export const SITE = {
  name: "Kingston Coffee Co.",
  fullName: "The Kingston Coffee Company",
  phone: "360-204-8090",
  phoneHref: "tel:+13602048090",
  email: "info@kingston.coffee",
  emailHref: "mailto:info@kingston.coffee",
  location: "Kingston, Washington",
  serviceArea: "the Greater Puget Sound area",
  images: {
    hero: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
    espresso: "https://images.unsplash.com/photo-1762657440624-d0b5cfae5bac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxlc3ByZXNzbyUyMHBvdXIlMjBsYXR0ZSUyMGFydCUyMGFydGlzYW5hbHxlbnwwfHx8fDE3ODA5NzA1NzN8MA&ixlib=rb-4.1.0&q=85",
    panini: "https://images.unsplash.com/photo-1621852004158-f3bc188ace2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxpdGFsaWFuJTIwcGFuaW5pJTIwYmFrZWQlMjBnb29kcyUyMGNhZmV8ZW58MHx8fHwxNzgwOTcwNTczfDA&ixlib=rb-4.1.0&q=85",
    eventSetup: "https://images.unsplash.com/photo-1750178942865-ba5449475e91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxtb2JpbGUlMjBjb2ZmZWUlMjBjYXJ0JTIwZXZlbnQlMjBjYXRlcmluZyUyMHJ1c3RpY3xlbnwwfHx8fDE3ODA5NzA1NzN8MA&ixlib=rb-4.1.0&q=85",
    baked: "https://images.unsplash.com/photo-1509440159596-0249088772ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
};
